import { Calculator } from '@dynameat/views/reporting/models';
import * as Sentry from '@sentry/vue';
import { PopularityQuery } from '../queries';
import { POPULARITY } from '../constants';

export class PopularityCalculator extends Calculator {
  kpiType = POPULARITY

  constructor(productGuid) {
    super();
    this.productGuid = productGuid;
  }

  async calculateKPI() {
    const popularityResponse = await this.executeUncubeQuery(PopularityQuery, this.productGuid);
    const popularityResults = this.processPopularity(popularityResponse.data.result[0]);
    const groupResponse = await this.executeUncubeQuery(PopularityQuery, null, popularityResults.groupOfPricing);
    const groupResults = groupResponse.data.result.map(this.processPopularity);
    const props = this.getData(popularityResults, groupResults);
    return this.getModelToInstance(props);
  }

  executeUncubeQuery(queryClass, ...args) {
    // eslint-disable-next-line new-cap
    const uncubeQuery = new queryClass(...args);
    return uncubeQuery.execute();
  }

  processPopularity(rawResponse) {
    if (rawResponse && rawResponse.length > 0) {
      return {
        popularity: rawResponse[1],
        groupOfPricing: rawResponse[0]
      };
    }
    Sentry.captureMessage('Popularity query was empty');
    return {
      popularity: 0,
      groupOfPricing: ''
    };
  }

  getData(popularityResults, groupResults) {
    const currentKpi = this.getValueOfKpi(popularityResults, groupResults);
    return {
      key: this.productGuid,
      kpi: currentKpi,
      increment: null,
      type: this.kpiType,
    };
  }

  getValueOfKpi(popularityResults, groupResults) {
    const avgPopularity = groupResults.reduce((acc, current) => acc + current.popularity, 0) / groupResults.length;
    // Clamp the result to 2, as it is the maximum in the radar chart.
    return Math.min((popularityResults.popularity / avgPopularity) || 0, 2);
  }
}
